import { useState } from "react";
import { Copy, Check } from "lucide-react";
import { toast } from "sonner";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { NETWORK_CONFIG } from "@/constants/network";

const RPC = NETWORK_CONFIG.rpcUrls[0];
const ID = NETWORK_CONFIG.chainId;

const SNIPPETS = {
  ethers: `import { ethers } from "ethers";

const provider = new ethers.JsonRpcProvider("${RPC}", { name: "fsc", chainId: ${ID} });
console.log(await provider.getBlockNumber());`,
  hardhat: `// hardhat.config.js
module.exports = {
  solidity: "0.8.24",
  networks: {
    fsc: {
      url: "${RPC}",
      chainId: ${ID},
      accounts: [process.env.PRIVATE_KEY],
    },
  },
};
// npx hardhat run scripts/deploy.js --network fsc`,
  foundry: `# foundry.toml
[rpc_endpoints]
fsc = "${RPC}"

# deploy
forge create src/MyToken.sol:MyToken --rpc-url fsc --private-key $PRIVATE_KEY --broadcast
cast block-number --rpc-url ${RPC}`,
};
const LABELS = { ethers: "ethers.js", hardhat: "Hardhat", foundry: "Foundry" };

const Snippet = ({ id, code }) => {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    await navigator.clipboard.writeText(code);
    setCopied(true);
    toast.success(`${LABELS[id]} snippet copied`);
    setTimeout(() => setCopied(false), 1500);
  };
  return (
    <div className="relative">
      <button data-testid={`status-snippet-copy-${id}`} onClick={copy} title="Copy snippet"
        className="absolute top-2 right-2 p-1.5 rounded border border-[#2A2411] bg-[#0A0A0A] hover:border-[#D4AF37]/50 transition-colors">
        {copied ? <Check size={14} className="text-green-400" /> : <Copy size={14} className="text-[#D4AF37]" />}
      </button>
      <pre data-testid={`status-snippet-code-${id}`} className="overflow-x-auto p-4 pr-12 rounded-md bg-[#050505] border border-[#2A2411] font-mono text-xs leading-relaxed text-zinc-300">{code}</pre>
    </div>
  );
};

export const RpcSnippets = () => (
  <Tabs defaultValue="ethers" data-testid="status-snippets">
    <TabsList className="bg-[#050505] border border-[#2A2411]">
      {Object.keys(SNIPPETS).map((id) => (
        <TabsTrigger key={id} value={id} data-testid={`status-snippet-tab-${id}`}
          className="text-xs data-[state=active]:bg-[#D4AF37] data-[state=active]:text-black">{LABELS[id]}</TabsTrigger>
      ))}
    </TabsList>
    {Object.entries(SNIPPETS).map(([id, code]) => (
      <TabsContent key={id} value={id} className="mt-3"><Snippet id={id} code={code} /></TabsContent>
    ))}
  </Tabs>
);
